// export const URL=`http://localhost:8000/api`;
export const URL=`https://checkagroapi.rehagro.com.br/api`;
// export const URL=`https://reembolsohomologapi.rehagro.com.br/api`;
// export const URL=`https://reembolsoapi.rehagro.com.br/api`;